import React from 'react'

import './HoursCounter.scss'
import Counter from 'components/Counter'

const formatValue = value => `${value} hrs`

export default function HoursCounter (props) {
  return <Counter {...props} formatValue={formatValue} />
}



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/HoursCounter/HoursCounter.js